"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Get run length
 *
 * @param  {Object}  run
 * @return {number} length
 */

var length = function length(run) {
  return run.end - run.start;
};

var _default = length;
exports["default"] = _default;